import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";

function FeeSubmission() {
  const [course, setCourse] = useState("");

  useEffect(() => {
    loadCaptchaEnginge(6);
  }, []);

  const handleCourseChange = (e) => {
    setCourse(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const user_captcha = e.target.captcha.value;

    if (validateCaptcha(user_captcha) === true) {
      e.target.action = "https://formsubmit.co/vbumca@gmail.com";
      e.target.method = "POST";
      e.target.submit();
    } else {
      alert("Captcha does not match. Please try again.");
      loadCaptchaEnginge(6);
      e.target.captcha.value = "";
    }
  };

  const getSemesters = () => {
    const maxSem = course === "MCA" ? 4 : 6;
    let sems = [];
    for (let i = 1; i <= maxSem; i++) {
      sems.push(<option key={i} value={i}>{i}</option>);
    }
    return sems;
  };

  return (
    <>
      <Helmet>
        <title>Fee Submission - VBU MCA</title>
      </Helmet>
      <div className="PageContainer">
        <div className="FeeSubmissionSection" data-aos="fade-up">
          <div className="FeeFormContainer">
            <div id="Heading" className="CenterHeading">
              <h1>Fee Submission Form</h1>
            </div>
            <form className="FeeForm" onSubmit={handleSubmit} method="POST">
              <input type="hidden" name="_subject" value="New Fee Submission Notification - VBU MCA" />
              <div className="FormRow">
                <input type="text" name="name" placeholder="Name" required />
                <input type="text" name="roll_no" placeholder="Class Roll No." required />
              </div>
              <div className="FormRow">
                <select name="course" onChange={handleCourseChange} value={course} required>
                  <option value="">Course</option>
                  <option value="BCA">BCA</option>
                  <option value="MCA">MCA</option>
                </select>
                <select name="semester" required>
                  <option value="">Semester</option>
                  {getSemesters()}
                </select>
                <input type="text" name="session" placeholder="Session" required />
              </div>

              <div className="FormRow">
                <input type="text" name="amount" placeholder="Amount" required />
              </div>
               <div className="FormRow" style={{ alignItems: 'center' }}>
                 <LoadCanvasTemplate />
                 <input
                   type="text"
                   name="captcha"
                   placeholder="Enter Captcha Here"
                   className="capthca_box"
                   required
                   style={{ width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '8px' }}
                 />
               </div>
               <div className="FormAction">
                <button type="submit" className="SubmitBtn">Submit</button>
              </div>
            </form>
          </div>

          <div className="AccountDetailsBox">
            <h3>Account Details</h3>
            <div className="AccountInfo">
              <p>Punjab National Bank</p>
              <p>Vbu Branch Hazaribagh</p>
              <ul>
                <li>Account No - <strong>0877050000949</strong></li>
                <li>IFSC Code - <strong>PUNB0174020</strong></li>
                <li>A/C Holder - Director MCA</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FeeSubmission;
